import React from "react";

export default function StatusBadge({ status, testId }) {
  return (
    <span
      className={`status-badge status-${status}`}
      data-testid={testId || `status-badge-${String(status).toLowerCase()}`}
    >
      <span
        className="w-1.5 h-1.5 rounded-full"
        style={{ background: "currentColor" }}
      />
      {status}
    </span>
  );
}
